import styled from 'styled-components'

export const Container = styled.div`
  ${props => props.theme.css.containerWide};
  margin: 50px auto 60px;

  p {
    text-align: center;
  }

  button {
    margin: 0 0 30px;

    > div {
      display: flex;
    }

    svg {
      width: 16px;
      height: 16px;
      margin-right: 20px;
      fill: ${props => props.theme.palette.general.light};
    }
  }
`
